import ResourceManager from "@/components/admin/ResourceManager";

export default function BlogAdmin() {
  return (
    <ResourceManager
      collection="blog_posts" title="Blog" subtitle="Rédigez et publiez vos articles."
      aiKind="article"
      columns={[
        { key: "title", label: "Titre" },
        { key: "category", label: "Catégorie" },
        { key: "author", label: "Auteur" },
      ]}
      fields={[
        { name: "title", label: "Titre", type: "text" },
        { name: "category", label: "Catégorie", type: "select", options: ["Transformation digitale", "Logiciels", "Hardware", "Cybersécurité", "Réseaux", "Conseils IT", "Actualités"] },
        { name: "author", label: "Auteur", type: "text" },
        { name: "excerpt", label: "Extrait / sous-titre", type: "textarea" },
        { name: "content", label: "Contenu", type: "richtext", ai: true, aiFrom: "title" },
        { name: "cover", label: "Image principale (URL)", type: "text" },
        { name: "read_time", label: "Temps de lecture (min)", type: "text" },
        { name: "seo_title", label: "SEO — Meta title", type: "text" },
        { name: "seo_description", label: "SEO — Meta description", type: "textarea" },
        { name: "seo_keywords", label: "SEO — Mots-clés", type: "text" },
      ]}
    />
  );
}
